<template>
    <FilterBody
        v-model:search-model-value="companyManagerFilterProperties.searchTerm"
        :label="t('projectclient.projectlist.table.companyManager.header')"
        :display-search="true"
        :search-placeholder="t('projectclient.projectlist.topbar.filters.companymanager.search.placeholder')"
        :items="companyManagerFilterProperties.displayedResults"
        :selected-items="screenSizeSearchParams.companyManagers"
        :pending="companyManagerFilterProperties.pending"
        :display-show-more="companyManagerFilterProperties.hasMoreToShow && !companyManagerFilterProperties.isSearchActive"
        @reset="projectListFiltersStore.handleResetCategory('companyManagers')"
        @check:item="handleCheckBoxChange"
        @show-more="handleShowMore"
    >
        <template #item="{item}">
            {{
                `${item.label === 'deleted.account.firstName' ? t('deleted.account.firstName') : item.label} ${
                    item.count > 0 ? `(${item.count})` : ''
                }`
            }}
        </template>
    </FilterBody>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import type {TypedAggregationResource} from '@common/composables';
    import {useScreenSizeStore} from '@common/stores';
    import {useProjectsListStore, useProjectsListFiltersStore} from '@features/projects-list/stores';
    import {storeToRefs} from 'pinia';
    import {useTranslation} from '#imports';
    import FilterBody from '../wrappers/FilterBody.vue';

    const {t} = useTranslation();

    const screenSizeStore = useScreenSizeStore();
    const {isSmallScreen} = storeToRefs(screenSizeStore);

    const projectListStore = useProjectsListStore();
    const {searchParams} = storeToRefs(projectListStore);

    const projectListFiltersStore = useProjectsListFiltersStore();
    const {temporarySearchParams, companyManagerFilterProperties} = storeToRefs(projectListFiltersStore);

    const screenSizeSearchParams = computed(() => {
        if (isSmallScreen.value) {
            return temporarySearchParams.value;
        } else {
            return searchParams.value;
        }
    });

    function handleCheckBoxChange(item: TypedAggregationResource<string>) {
        projectListFiltersStore.handleUpdateCategory('companyManagers', item.value);
    }

    function handleShowMore() {
        companyManagerFilterProperties.value.resultsSize += 6;
    }
</script>
